import React from "react";

export default function AcademicCalendar() {
  return (
    <div className="p-4" id="academic-calendar">
      <h2 className="text-xl mb-4">একাডেমিক ক্যালেন্ডার</h2>
      <div>
        <p>
          📅 গুরুত্বপূর্ণ তারিখ, ক্লাস, কুইজ ও পরীক্ষার সময়সূচি এখন হাতের মুঠোয়।
        </p>
        <p>⏰ টাইম ম্যানেজমেন্ট হবে সহজ।</p>
        <p>🔔 নোটিফিকেশনে থাকুন আপডেটেড।</p>
        <p>📱 যেকোনো ডিভাইসে অ্যাক্সেস করুন।</p>
        <p>🚫 কিছুই মিস হবে না!</p>
        <p></p>
      </div>

      <div className="flex justify-center my-5">
        <iframe
          src="https://calendar.google.com/calendar/embed?height=600&wkst=7&ctz=Asia%2FDhaka&showTitle=0&showCalendars=0&src=YThmMzJhYzg3NjRjMmFjMTExYTA4YTlmMzEyZGFhMmJlNDdiOWVjNjdiZjZjNjFlNmE5YTJjZGJkNDg2MGNkOUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23B39DDB"
          width="1000"
          height="600"
          scrolling="no"
          frameBorder="0"
          title="Academic Calendar"
        />
      </div>
    </div>
  );
}
